import { ApiBind, CommonSearchParam } from './common-search-param.model';
import { MediaType } from '../constants';

/**
 * 配信PF予約登録の検索条件を表すクラス.
 *
 * @class
 * @extends CommonSearchParam
 */
export class PlatformReservationSearchParam extends CommonSearchParam {

  constructor(
    name?: string,
    mediaTypes?: MediaType[],
    platformId?: number,
  ) {
    super();
    this.name = name;
    this.mediaTypes = mediaTypes;
    this.platformId = platformId;
  }

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'media_types' })
  mediaTypes: MediaType[];

  @ApiBind({ column: 'platform_id' })
  platformId: number;
}
